export default {"src":"/_next/static/media/demo.14c52651.svg","height":453,"width":302,"blurWidth":0,"blurHeight":0};